// extracted by mini-css-extract-plugin
export var columnList = "_h7-0";